/*
 * File: form-file-classic.ts
 * File Created: 2024-02-17 12:22:51
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-10-14 09:28:11
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import { BaseFormComponent } from "@root/components/form/core/lib/base-form-component";
import { PropInnateSync } from "@root/core/vue-props";
import {
    IFormComponentAttr,
    IFormValidateResult,
} from "@root/components/form/core/lib/core";

@Component
export default class FormFileClassic extends BaseFormComponent {
    @PropInnateSync("value", { type: [File, Array], default: undefined })
    innateValue!: File | File[] | undefined;

    // required validation for file
    defaultRequired(o: IFormComponentAttr): IFormValidateResult {
        let value = o.value;
        let state: NonNullable<IFormValidateResult>["state"] = undefined;
        let message: NonNullable<IFormValidateResult>["message"] = null;

        do {
            /// if null, show "required field" message.
            if (value == null || (Array.isArray(value) && value.length == 0)) {
                state = false;
                message = this.$_("w_RequiredField");
                break;
            }
        } while (0);
        return { state, message };
    }
}
